















































import { Watch, Prop, Component, Vue } from "vue-property-decorator";
import { Task } from "@/api/task-api";
import ITaskOutputOptions from "@/api/models/ITaskOutputOptions";

import CheckDayOfWeek from "@/components/CheckDayOfWeek.vue";
import VTaskSubtaskControl from "./VTaskSubtaskControl.vue";
import parseDateTime from "../../helpers/parseDateTime";
import formatDateTime from "../../helpers/formatDateTime";

@Component({
  components: {
    CheckDayOfWeek,
    VTaskSubtaskControl
  }
})
export default class VTaskControl extends Vue {
  @Prop({ required: true }) task!: Task;
  @Prop({ required: true }) options!: ITaskOutputOptions;

  get start(): string {
    return formatDateTime(this.task.start);
  }

  set start(start: string) {
    this.task.start = parseDateTime(start);
  }

  get end(): string {
    return formatDateTime(this.task.end);
  }

  set end(end: string) {
    this.task.end = parseDateTime(end);
  }

  validateDate() {
    const end = this.$refs.end as HTMLInputElement;
    if (this.task.start > this.task.end) {
      end.setCustomValidity("終了日は開始日以降に設定してください");
    } else {
      end.setCustomValidity("");
    }
  }

  @Watch("options.hasSubTasks")
  private initSubTask(hasSubTasks: boolean) {
    if (!hasSubTasks) return;
    if (this.task.subTasks.length === 0) {
      this.task.subTasks.push({
        taskId: "",
        name: "",
        done: false,
        behind: false,
        created: new Date(),
        dueDate: ""
      });
    }
    this.$nextTick(() => {
      (this.$refs.subtasks as VTaskSubtaskControl).focus();
    });
  }
}
